import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ReservationPriority } from './reservation-priority.model';
import { ReservationPriorityPopupService } from './reservation-priority-popup.service';
import { ReservationPriorityService } from './reservation-priority.service';

@Component({
    selector: 'jhi-reservation-priority-delete-dialog',
    templateUrl: './reservation-priority-delete-dialog.component.html'
})
export class ReservationPriorityDeleteDialogComponent {

    reservationPriority: ReservationPriority;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationPriorityService: ReservationPriorityService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['reservationPriority']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.reservationPriorityService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'reservationPriorityListModification',
                content: 'Deleted an reservationPriority'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-reservation-priority-delete-popup',
    template: ''
})
export class ReservationPriorityDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationPriorityPopupService: ReservationPriorityPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.reservationPriorityPopupService
                .open(ReservationPriorityDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority-delete-dialog.component.ts